// Lightweight Google Analytics 4 wrapper. No-ops safely when no Measurement ID
// is configured (REACT_APP_GA4_ID), so it never breaks the app or logs errors.
const GA_ID = process.env.REACT_APP_GA4_ID;

export function initGA() {
  if (!GA_ID || typeof window === "undefined" || window.__gaInit) return;
  window.__gaInit = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageview(path) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
}

export function trackEvent(name, params = {}) {
  if (!window.gtag) return;
  window.gtag("event", name, params);
}
